<template>
  <dialog 
    id="about"
    ref="about">
    <button @click.prevent="hideAbout"/>

    <header>
      <p>Beta build: {{ cst.BUILD_VERSION }}</p>
      <p>Copyright &#169; UX-FLO B.V. All rights reserved.</p>
      <p>Patent pending: <strong>#US2017/0139723-A1</strong></p>
    </header>

    <footer>
      <p>Designed in Amsterdam</p>
      <p>Developed in Toronto, Gouda, Glasgow, &amp; Munich</p>
    </footer>
  </dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as cst from '../../lib/constants'

export default {
  name: 'About',
  data() {
    return {
      cst,
    }
  },
  computed: {
    ...mapGetters(['relativeWidth', 'relativeHeight']),
  },
  created() {
    this.$eventBus.$on('show-about', () => {
      this.$refs['about'].showModal()
    })
  },
  methods: {
    hideAbout() {
      this.$refs['about'].close()
    },
    email() {
      const emailEl = this.$refs.email
      const address = emailEl ? emailEl.dataset.name + '@' + emailEl.dataset.domain + '.' + emailEl.dataset.tld : ''
      if (address.length) {
        window.location.href = 'mailto:' + address
      }
    },
  },
}
</script>

<style lang="scss">
#about {
  border: none;
  width: 500px;
  height: 320px;
  z-index: 1000;
  text-align: center;
  border-radius: 8px;
  box-shadow: 1px 1px 10px #333;
  box-sizing: border-box;
  padding: 25px;
  line-height: 150%;
  font-size: 10pt;
  background: #e6e6e6 url('../../assets/INFO_graphic.svg') center center no-repeat;

  button {
    width: 15px;
    height: 15px;
    padding: 0;
    background: #f96160;
    border-radius: 15px;
    position: absolute;
    left: 8px;
    top: 9px;
    border: 1px solid #e0504f;
    cursor: pointer;
  }

  header {
    margin: 90px 0 20px;

    > p > span {
      display: inline-block;
      font-size: 12pt;
      margin: 15px 0 0;
    }

    > p > span > a {
      font-weight: bold;
    }
  }

  footer {
    font-size: 9pt;
  }
}
</style>
